function e(e, n) {
  return (e, n) => {};
}
export { e };
